import { useEffect, useState } from "react";
import { useImageStore } from "entity-store/image-store/use-image-store";
import { ProjectTemplate } from "PosterEditor/model/project-template";
import { fullThumbnailSizeFromPreset } from "PosterEditor/model/poster-project";
import { aspectFitSize } from "PosterEditor/utils/rect-utils";
import { truncate } from "node:fs";
import { Size } from "PosterEditor/model/poster-types";

interface UseTemplateThumbnailProps {
  template: ProjectTemplate;
  //Desired size - will be aspect-fit to this size,
  //and actual size will be returned.
  size: Size;
}
export const useTemplateThumbnail = (props: UseTemplateThumbnailProps) => {
  const [snapshot, setSnapshot] = useState<string | null>(null);
  const { getImageUrl } = useImageStore();

  useEffect(() => {
    let objectURL: string | null = null;
    const fetchSnapshot = async () => {
      const url = await getImageUrl(props.template.thumbnail, true);
      objectURL = url;
      setSnapshot(url);
    };

    fetchSnapshot();

    return () => {
      if (objectURL) {
        URL.revokeObjectURL(objectURL);
      }
    };
  }, []);

  const mapStyle = props.template.project.mapStyle?.replace(
    /^mapbox:\/\/styles\/jamesbkelly\//,
    ""
  );
  const mapImageURL = `/pallete-components/map-thumbnails/${mapStyle}.png`;

  const image = snapshot || props.template.thumbnail || mapImageURL;

  const size = fullThumbnailSizeFromPreset(props.template.project.size);

  const scaled = aspectFitSize(size, {
    width: props.size.width,
    height: props.size.height,
  });

  return { image, size: scaled };
};
